import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-manual-tarification',
    templateUrl: './credit-manual-tarification.component.html',
    styleUrls: ['./credit-manual-tarification.component.scss'],
    standalone: false
})
export class CreditManualTarificationComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  diProducts: any[] = [];
  isDigitalInsure = true;
  selectedProductName = '';

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const partnerFlux = pledge?.products?.[0]?.parameters?.partnerFlux;
    this.isDigitalInsure = partnerFlux === 'DIGITAL_INSURE';

    if (this.isDigitalInsure) {
      this.productDao.getDigitalInsureProducts().subscribe(products => {
        this.diProducts = products || [];
      });
    } else {
      // Non-DI : afficher le produit déjà sélectionné (read-only)
      this.selectedProductName = pledge?.products?.[0]?.productName || '';
    }

    this.subscriptionFacade.initForm(this);

    // Pour les non-DI, pré-remplir choosedProductCode avec le nom du produit pour valider le formulaire
    if (!this.isDigitalInsure && this.selectedProductName) {
      this.form?.get('products')?.get('0')?.get('parameters')
        ?.get('manualTarification')?.get('choosedProductCode')
        ?.setValue(this.selectedProductName, { emitEvent: false });
    }
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
